import MojitoServices from 'mojito/services';
import BetHistoryView from './view/index.js';
import { useSelector, shallowEqual } from 'react-redux';

const {
    selectBets,
    selectIsFetching,
    selectPagination,
    selectStatusFilter,
    selectRangeFilter,
    selectError,
} = MojitoServices.Bets.betHistorySelectors;
const { selectError: selectPdfError, selectIsFetching: selectIsPdfFetching } =
    MojitoServices.Pdf.selectors;
const { isLoggedIn } = MojitoServices.Authentication.selectors;

export default function BetHistory(props) {
    const onItemClicked = item => props.onBetClick(item.id);
    const betProps = useSelector(
        state => ({
            pagination: selectPagination(state),
            betHistory: selectBets(state),
            isFetchingBetHistory: selectIsFetching(state),
            selectedStatusFilter: selectStatusFilter(state),
            selectedRangeFilter: selectRangeFilter(state),
            error: selectError(state),
        }),
        shallowEqual
    );
    const pdfData = useSelector(
        state => ({
            isFetching: selectIsPdfFetching(state),
            hasError: selectPdfError(state),
        }),
        shallowEqual
    );
    const userLoggedIn = useSelector(state => isLoggedIn(state));

    return (
        <div className="ta-BetHistory">
            <BetHistoryView
                {...betProps}
                pdfData={pdfData}
                onItemClicked={onItemClicked}
                userLoggedIn={userLoggedIn}
            />
        </div>
    );
}
